import { Component } from '@angular/core';

@Component({
  selector: 'app-food-journaling-loader',
  templateUrl: './food-journaling-loader.component.html',
  styleUrls: ['./food-journaling-loader.component.css']
})
export class FoodJournalingLoaderComponent {

}
